import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import "./SwitchComponent.scss";

interface ISwitchComponentProps {
    componentId?: string;
    checked: boolean;
    onSwitchClick?: () => void;
}

class SwitchComponent extends BaseReactComponent<ISwitchComponentProps> {
    private readonly _componentId = "switch_component";

    public render(): JSX.Element {
        return (
            <div id={this.props.componentId ?? this._componentId} className="switch-container">
                <div className="switch" onClick={() => this.props.onSwitchClick?.()}>
                    <input type="checkbox" checked={this.props.checked} />
                    <span className="slider" />
                </div>
            </div>
        );
    }
}

export { SwitchComponent };
